import liepinLogo from '@public/images/2026/liepin-logo.svg'
import heroDesktop from '@public/images/2026/hero-desktop.jpg'
import heroMobileMark from '@public/images/2026/feifan-2026-mark.png'
import sloganImage from '@public/images/2026/work-different.svg'
import consultationQr from '@public/images/2026/consultation-qr.jpeg'
import circleGradient from '@public/images/2026/circle-gradient.png'
import aboutToggle from '@public/images/2026/about-toggle.svg'
import timelineDot from '@public/images/2026/timeline-dot.svg'
import propositionToggleLightBlue from '@public/images/2026/proposition-toggle-light-blue.svg'
import propositionToggleBlue from '@public/images/2026/proposition-toggle-blue.svg'
import propositionTogglePurple from '@public/images/2026/proposition-toggle-purple.svg'
import propositionToggleOrange from '@public/images/2026/proposition-toggle-orange.svg'

export const SITE_CONTENT = {
  signupUrl: 'https://liepin.wjx.cn/vm/QzeuY0z.aspx',
  brand: {
    name: '猎聘',
    logo: liepinLogo,
    heroDesktop,
    heroDesktopVideo:
      'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/d18820f35001834820646999893/fFGB6gSr1KIA.mp4',
    heroDesktopPoster: heroDesktop,
    heroMobileMark,
    heroMobileVideo:
      'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/ca7299795001834820646682140/OT9db6fcud4A.mp4',
    heroMobilePoster:
      'https://image0.lietou-static.com/img/6aa8eb9951d2181e0bb82c1306u.jpg',
    sloganImage,
    slogan: 'WORK DIFFERENT',
    year: '2026',
    title: '非凡',
  },
  navigation: [
    { label: '项目介绍', href: '#about' },
    { label: '核心命题', href: '#propositions' },
    { label: '时间流程', href: '#timeline' },
    { label: '立即报名', href: '#signup', isCta: true },
  ],
  media: {
    type: 'video',
    desktopSrc:
      'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/daaf91805001834820707659514/Vy3w9LM3mIMA.mp4',
    mobileSrc:
      'https://1500000890.vod2.myqcloud.com/6c9793f9vodcq1500000890/daaf91805001834820707659514/Vy3w9LM3mIMA.mp4',
    alt: '非凡 2026 项目介绍',
    poster:
      'https://image0.lietou-static.com/img/6aa9f5a6cf9f761993ffb6f604u.jpg',
  },
  assets: {
    circleGradient,
    aboutToggle,
    timelineDot,
    propositionToggles: {
      'light-blue': propositionToggleLightBlue,
      blue: propositionToggleBlue,
      purple: propositionTogglePurple,
      orange: propositionToggleOrange,
    },
  },
  about: {
    eyebrow: '项目介绍',
    english: 'ABOUT THE PROGRAM',
    mobileSecondParagraph:
      '基于这一时代命题，2026年，猎聘、清华经管学院人工智能与管理研究中心、清华大学可持续社会价值研究院联合发起“人工智能与智慧就业”研究项目—— RAISE（Research on AI and Smart Employment）。“RAISE”寓意“向上、向善”，旨在研究AI如何推动就业形态与组织能力持续演进，同时探索技术应用如何走向安全、可信与可持续。「非凡2026」作为RAISE项目组织研究的重要组成部分，将深入中国企业的真实实践，研究AI进入组织后，人、工作与组织之间正在形成的新关系。',
    lead: [
      'AI对企业的影响，正从个体效率的提升，走向对岗位、流程、协作、管理乃至组织运行逻辑的深层重构。当AI开始嵌入核心业务、参与复杂决策并逐步成为组织能力的一部分，企业面对的已不再只是“如何使用AI”，而是如何重新设计工作、重新定义人的价值，并建立人与AI共同进化的组织方式。',
      '基于这一时代命题，2026年，猎聘、清华经管学院人工智能与管理研究中心、清华大学可持续社会价值研究院联合发起“人工智能与智慧就业”研究项目—— RAISE（Research on AI and Smart Employment）。“RAISE”寓意“向上、向善”，旨在研究AI如何推动就业与组织能力向上发展，同时探索技术应用如何走向安全、可信与可持续。「非凡2026」作为RAISE项目组织研究的重要组成部分，将深入中国企业的真实实践，研究AI进入组织后，人、工作与组织之间正在形成的新关系。',
    ],
    extended: [
      '在人的能力研究中，本项目采用4A分析框架：Automation（自动），关注AI如何实现并承接人类原有能力；Augmentation（增强），关注AI如何带来人类原本不具备的新能力；Adaptation（适配），关注人如何调整工作内容与工作方式以适应AI；Assurance（保障），关注组织如何确保AI应用的安全、合规与可信。通过这一框架，「非凡2026」不只关注企业“用了多少AI”，更希望深入分析AI如何改变人的能力边界、岗位的任务结构、组织的协作方式与管理机制，以及企业如何在效率、创新与责任之间建立新的平衡。',
      '本次研究面向所有正在开展 AI 组织探索的企业。无论是 AI 原生组织，还是尚处在早期探索阶段的企业，均诚邀作为本次研究的共创伙伴。我们希望依托来自不同产业、不同规模、不同发展阶段的真实样本，系统描绘中国企业的 AI 组织进化全貌，深度拆解企业落地实践、沉淀经验与现实困境，并提炼具备参考价值的组织演进路径。',
      '「非凡2026」不以单一的技术成熟度评价企业，也不试图用一套既定标准定义所有组织。我们希望以真实实践为基础，为AI时代的组织研究提供来自中国企业的样本与证据，也为企业管理者和HR理解组织变化、判断自身阶段、寻找下一步进化方向提供参考。',
    ],
  },
  propositions: {
    heading: '在这项研究中，\n我们期待与您共同完成四个核心命题',
    desktopHeading: '在这项研究中，\n我们期待与您共同完成\n四个核心命题',
    items: [
      {
        number: '01',
        color: 'light-blue',
        title: '描绘中国组织的AI进化图谱',
        body:
          '全面呈现AI进入真实业务与管理场景后，中国企业在组织结构、岗位分工、人才需求与运行方式上发生的变化。',
      },
      {
        number: '02',
        color: 'blue',
        title: '记录企业的探索实践与挑战',
        body:
          '从AI的初步应用，到深度嵌入核心流程，再到岗位、协作与管理机制的系统重构，深入剖析处于不同进化阶段的企业所作出的实践选择、积累的经验与面临的现实挑战。',
      },
      {
        number: '03',
        color: 'purple',
        title: '定义碳硅能力空间，重新认识人的价值',
        body:
          '研究AI时代的人机协作方式，人机协作过程中人的能力与角色变化，重新认识人的能力空间与价值定位。',
      },
      {
        number: '04',
        color: 'orange',
        title: '发现AI时代的非凡组织代表',
        body:
          '寻找答案各不相同、却已在各自发展阶段形成代表性实践的组织，从中提炼可供更多企业借鉴的思路与路径。',
      },
    ],
  },
  timeline: {
    eyebrow: '时间流程',
    english: 'TIMELINE',
    items: [
      {
        date: '9月16日',
        title: '正式启动',
        description: '非凡2026上线\n企业调研正式开启',
      },
      {
        date: '9月16日 - 10月15日',
        title: '企业问卷调研',
        description: '企业填写问卷，持续扩大研究样本，\n收集真实组织实践',
      },
      {
        date: '10月20日 - 10月31日',
        title: '企业共创会',
        description: '北京/上海/深圳三地座谈\n邀请有深度AI实践的企业参与',
      },
      {
        date: '11月20日',
        title: '非凡盛典-年度高峰论坛',
        mobileTitle: '非凡盛典\n|\n年度高峰论坛',
        description: '联合清华年度发布',
      },
      {
        date: '11月25日 - 12月10日',
        title: '非凡之旅-闭门交流会',
        mobileTitle: '非凡之旅\n|\n闭门交流会',
        description: '各地结合现有市场活动\n开展非凡主题小型Call High',
      },
    ],
  },
  signup: {
    title: '「非凡2026」正式启航',
    description: '如有任何疑问，可添加「猎聘非凡助手」获取一对一咨询',
    qrSrc: consultationQr,
    qrLabel: '非凡2026项目咨询二维码',
  },
  contact: {
    heading: '联系我们',
    english: 'Contact us',
    media: '媒体合作\nchensi@liepin.com',
    consultation: '活动咨询\nfeifan@liepin.com',
    legal:
      '津ICP备15007986号-11  ICP经营许可证：合字B2-20160007  京公网安备 11010502035189号\nCopyright © 2006-2023 liepin.com All Rights Reserved  违法和不良信息举报',
  },
}
